import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Slider, IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import ZoomIn from '@mui/icons-material/ZoomIn';
import ZoomOut from '@mui/icons-material/ZoomOut';
var useStyles = makeStyles()(function (theme) {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    slider: {
      width: 70,
      color: theme.palette.text.secondary
    }
  };
});
function ZoomControls(_ref) {
  var model = _ref.model;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var maxBpPerPx = model.maxBpPerPx,
    minBpPerPx = model.minBpPerPx,
    bpPerPx = model.bpPerPx,
    scaleFactor = model.scaleFactor;
  var _useState = useState(-Math.log2(bpPerPx) * 100),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  useEffect(function () {
    setValue(-Math.log2(bpPerPx) * 100);
  }, [setValue, bpPerPx]);
  return React.createElement("div", {
    className: classes.container
  }, React.createElement(IconButton, {
    "data-testid": "zoom_out",
    onClick: function onClick() {
      return model.zoom(bpPerPx * 2);
    },
    disabled: bpPerPx >= maxBpPerPx - 0.0001 || scaleFactor !== 1,
    size: "large"
  }, React.createElement(ZoomOut, null)), React.createElement(Slider, {
    size: "small",
    className: classes.slider,
    value: value,
    min: -Math.log2(maxBpPerPx) * 100,
    max: -Math.log2(minBpPerPx) * 100,
    onChange: function onChange(_, val) {
      return setValue(val);
    },
    onChangeCommitted: function onChangeCommitted() {
      return model.zoomTo(Math.pow(2, -value / 100));
    },
    disabled: scaleFactor !== 1
  }), React.createElement(IconButton, {
    "data-testid": "zoom_in",
    onClick: function onClick() {
      return model.zoom(model.bpPerPx / 2);
    },
    disabled: bpPerPx <= minBpPerPx + 0.0001 || scaleFactor !== 1,
    size: "large"
  }, React.createElement(ZoomIn, null)));
}
export default observer(ZoomControls);